import { Pageable, Sort } from './commons.model';

export enum Classification {
    UW = 'UW',
    NW = 'NW',
    OW = 'OW',
    OB = 'OB'
}

export interface CreatePatient{
    firstName: string;
    lastName: string;
    informedConsent: boolean;
    enrolledOn: string;
    demoscopicData?: CreatePatientDemoscopicData;
    parentData?: PatientParentData;
}

export interface CreatePatientDemoscopicData{
    birthDay: Date;
    sex: Sex;
    ethnicity: string;
    municipalityId?: string;
}

export interface CreatePatientMeasurement{
    date: Date;
    hipCircumference: number;
    abdominalCircumference: number;
    neckCircumference: number;
    percentiles: number;
    systolicPressure: number;
    diastolicPressure: number;
    weight: number;
    height: number;
    pulse: number;
    otherPathologies: boolean;
    steatosis: boolean;
    integration: boolean;
    classification: Classification;
    notes?: string;
}

export enum Ethnicity{
    CAUCASIAN = 'CAUCASIAN',
    MONGOLIAN = 'MONGOLIAN',
    ETHIOPIAN = 'ETHIOPIAN',
    AMERICA = 'AMERICA',
    MALAY = 'MALAY'
}

export interface Municipality{
    id: string;
    name: string;
}

export interface Nation{
    id: string;
    name: string;
}

export interface Patient{
    code: number;
    demoscopicData: PatientDemoscopicData;
    dismissedOn: Date;
    enrolledOn: Date;
    firstName: string;
    id: string;
    informedConsent: boolean;
    lastName: string;
    parentData: PatientParentData;
}

export interface PatientClassification{
    classification: Classification;
    id: string;
    integration: boolean;
    steatosis: boolean;
}

export interface PatientDemoscopicData{
    birthDay: Date;
    ethnicity: Ethnicity;
    municipality: Municipality;
    nation: Nation;
    province: Province;
    region: Region;
    sex: Sex;
}

export interface PatientFilter{
    birthDateFrom?: Date;
    birthDateTo?: Date;
    enrollmentDate?: Date;
    dismissedDate?: Date;
    sex?: Sex;
    ethnicity?: Ethnicity;
    nationId?: string;
    regionId?: string;
    provinceId?: string;
    municipalityId?: string;
    informedConsent?: boolean;
    classification?: Classification;
}

export interface PatientMeasurement extends CreatePatientMeasurement{
    id: string;
}

export interface PatientMeasurementFilter{
    from?: Date;
    to?: Date;
}

export interface PatientsMeasurementPage {
    content: PatientMeasurement[];
    empty: boolean;
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    pageable: Pageable;
    size: number;
    sort: Sort;
    totalElements: number;
    totalPages: number;
}

export interface PatientSearchPage {
    content: Patient[];
    empty: boolean;
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    pageable: Pageable;
    size: number;
    sort: Sort;
    totalElements: number;
    totalPages: number;
}

export interface PatientParentData{
    parentCellphone?: string;
    parentEmail?: string;
    parentFirstName: string;
    parentLastName: string;
    parentPhone?: string;
}

export interface Province{
    id: string;
    name: string;
}

export interface Region{
    id: string;
    name: string;
}

export enum Sex {
    MALE = 'MALE',
    FEMALE = 'FEMALE'
}

export interface UpdatePatient{
    firstName?: string;
    lastName?: string;
    informedConsent?: boolean;
    enrolledOn?: Date;
    dismissedOn?: Date;
}

export interface UpdatePatientDemoscopicData{
    birthDay?: Date;
    sex?: Sex;
    ethnicity?: Ethnicity;
    municipality?: Municipality;
}

export interface UpdatePatientMeasurement{
    date: Date;
    hipCircumference: number;
    abdominalCircumference: number;
    neckCircumference: number;
    percentiles: number;
    systolicPressure: number;
    diastolicPressure: number;
    weight: number;
    height: number;
    pulse: number;
    otherPathologies: boolean;
    steatosis: boolean;
    integration: boolean;
    classification: Classification;
    notes?: string;
}

export interface UpdatePatientParentData{
    parentLastName?: string;
    parentFirstName?: string;
    parentEmail?: string;
    parentCellphone?: string;
    parentPhone?: string;
}
